<template>
    <v-chip v-if="waterReportType === WaterReportTypesV1.TestStripScan" color="blue-darken-2">Image Scan</v-chip>
    <v-chip v-else-if="waterReportType === WaterReportTypesV1.TestStripPick" color="green-darken-2">Picked Colors</v-chip>
    <v-chip v-else-if="waterReportType === WaterReportTypesV1.TestStrip">Manual Test Strip</v-chip>
    <v-chip v-else-if="waterReportType === WaterReportTypesV1.SpinLab">Manual Spin Lab</v-chip>
    <v-chip v-else-if="waterReportType === WaterReportTypesV1.Manual">Manual</v-chip>
    <v-chip v-else>{{ waterReportType }}</v-chip>
</template>

<script lang="ts" setup>
import { type PropType } from 'vue'
import { WaterReportTypesV1 } from '@geckoal/gecko-api-client'

defineProps({
    waterReportType: {
        type: String as PropType<WaterReportTypesV1>,
        required: true
    }
})
</script>
